
<template>
  <div class="evaluateSupplier">
    <el-container>
      <el-header>
        <el-form
          ref="form"
          :model="Evaluateform"
          label-width="120px"
          :inline="true"
        >
          <el-row>
            <el-col :span="6">
              <el-form-item label="合同编号" prop="contractCode">
                <el-input
                  v-model="Evaluateform.contractCode"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="合同编号">
                <el-select
                  v-model="Evaluateform.contractCode1"
                  placeholder="请选择"
                  clearable
                >
                  <el-option
                    v-for="dept in deptList"
                    :key="dept.applyDeptId"
                    :label="dept.applyDeptName"
                    :value="dept.applyDeptId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-col :span="6">
              <el-form-item label="合作单位名称" prop="supplierName">
                <el-input
                  v-model="Evaluateform.supplierName"
                  autocomplete="off"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="项目部" prop="projectDeptId">
                <el-select
                  v-model="Evaluateform.projectDeptId"
                  placeholder="请选择"
                  clearable
                  @change="getProjectList"
                >
                  <el-option
                    v-for="dept in deptList"
                    :key="dept.applyDeptId"
                    :label="dept.applyDeptName"
                    :value="dept.applyDeptId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <div v-if="showAdvanceFilter">
              <el-col :span="6">
                <el-form-item label="项目名称" prop="projectId">
                  <el-select
                    v-model="Evaluateform.projectId"
                    placeholder="请选择项目名称"
                    filterable
                  >
                    <el-option
                      :label="projectItem.name"
                      :value="projectItem.id"
                      v-for="(projectItem, projectIndex) in projectList"
                      :key="'projectItem' + projectIndex"
                    ></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item
                  label="项目评分"
                  label-width="120px"
                  prop="isScored"
                >
                  <el-select
                    v-model="Evaluateform.isScored"
                    placeholder="请选择"
                    default-first-option
                  >
                    <el-option label="全部" value></el-option>
                    <el-option label="未评分" value="0"></el-option>
                    <el-option label="已评分" value="1"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item
                  label="主管部门综合评定"
                  label-width="120px"
                  prop="dutyDeptLevel"
                >
                  <el-select
                    v-model="Evaluateform.dutyDeptLevel"
                    placeholder="请选择"
                    default-first-option
                  >
                    <el-option label="全部" value></el-option>
                    <el-option label="优秀" value="3"></el-option>
                    <el-option label="良好" value="2"></el-option>
                    <el-option label="合格" value="1"></el-option>
                    <el-option label="不合格" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col> -->
              <el-col :span="6">
                <el-form-item
                  label="生产部门综合评定"
                  label-width="120px"
                  prop="productDeptLevel"
                >
                  <el-select
                    v-model="Evaluateform.productDeptLevel"
                    placeholder="请选择"
                    default-first-option
                  >
                    <el-option label="全部" value></el-option>
                    <el-option label="优秀" value="3"></el-option>
                    <el-option label="良好" value="2"></el-option>
                    <el-option label="合格" value="1"></el-option>
                    <el-option label="不合格" value="0"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <!-- <el-col :span="6">
                <el-form-item label="申请部门" label-width="120px">
                  <el-input v-model="Projectform.applyDeptId" placeholder="-请输入"></el-input>
                </el-form-item>
              </el-col>-->
            </div>
            <el-col :span="showAdvanceFilter ? 6 : 6">
              <div class="handlePanel">
                <el-button type="primary" icon @click="selectClick()"
                  >查询</el-button
                >
                <el-button type="info" icon @click="resetClick()"
                  >重置</el-button
                >
                <el-button type="text" @click="moreScreen">{{
                  showAdvanceFilter ? "收起" : "高级筛选"
                }}</el-button>
              </div>
            </el-col>
          </el-row>
        </el-form>

        <div style="clear: both"></div>
        <el-row>
          <el-col :span="24">
            <div class="handlePanel">
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="addAccountSetDlog()"
                v-if="btnAuthorize.evaluateUserSet.btnEnable"
                >评价账号设置</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="exportCurrentList()"
                v-if="btnAuthorize.export.btnEnable"
                >导出</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="openDeptProjectDig()"
                v-if="btnAuthorize.pjeDeptP.btnEnable"
                >项目部项目台账</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="openDeptDig()"
                v-if="btnAuthorize.pjeDeptTotleP.btnEnable"
                >项目部总台账</el-button
              >
              <el-button
                type="primary"
                icon="el-icon-download"
                @click="exportTotleList()"
                v-if="btnAuthorize.groupTotleP.btnEnable"
                >集团总台账</el-button
              >
            </div>
          </el-col>
        </el-row>
      </el-header>
      <el-main ref="main">
        <el-table
          ref="dataTable"
          :data="evaluateSupplier"
          highlight-current-row
          size="mini"
          height="100%"
          @selection-change="handleSelectionChange"
          @row-click="rowClicked"
          @cell-dblclick="subCategoryDetail"
          border
        >
          <el-table-column
            type="index"
            width="50"
            label="序号"
          ></el-table-column>
          <el-table-column
            v-for="(item, index) in tableColumnDatas"
            :key="index"
            :prop="item.class"
            :label="item.labelName"
            :sortable="item.sortEnable"
            show-overflow-tooltip
          >
            <!-- <template slot-scope="scope">
              <span v-if="item.isNumFilter">{{scope.row[scope.column.property]|numFilter}}</span>
              <span v-else>{{scope.row[scope.column.property]}}</span>
            </template> -->
          </el-table-column>
          <el-table-column label="操作" width="240px">
            <template slot-scope="scope">
              <el-button
                type="text"
                size="mini"
                @click="groupTotlePSet(scope.row)"
                >生产部门综合评定</el-button
              >
              <el-button
                type="text"
                size="mini"
                @click="masterTotlePSet(scope.row)"
                >主管部门综合评定</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-main>
      <el-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="pageIndex"
          :page-sizes="[10, 20, 30, 50, 100]"
          :page-size="pageSize"
          layout="total, prev, pager, next, sizes, jumper"
          :total="total"
        ></el-pagination>
      </el-footer>
    </el-container>

    <!-- 生产部门综合评定弹窗 -->
    <projectEvaluate ref="projectEvaluate" @close="initList" />

    <!-- 主管部门综合评定弹窗 -->
    <masterEvaluate ref="masterEvaluate" @close="initList" />

    <!-- x导出项目部项目台账 项目总台帐 -->
    <el-dialog
      width="400px"
      :title="isAdd ? '项目部项目台账' : '项目部总台账'"
      :visible.sync="isAddDialogShow"
      :close-on-click-modal="false"
    >
      <el-form
        ref="addForm"
        :model="addForm"
        label-width="80px"
        :rules="addRules"
      >
        <el-row>
          <el-col :span="21">
            <el-form-item label="项目部:" prop="projectDeptId">
              <el-select
                v-model="addForm.deptId"
                placeholder="请选择"
                clearable
                filterable=""
                @change="getExportProjectList(addForm.deptId)"
              >
                <el-option
                  v-for="dept in deptList"
                  :key="dept.applyDeptId"
                  :label="dept.applyDeptName"
                  :value="dept.applyDeptId"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row v-if="isAdd">
          <el-col :span="21">
            <el-form-item label="项目" prop="projectId">
              <el-select
                v-model="addForm.projectId"
                placeholder="请选择项目名称"
                filterable
              >
                <el-option
                  :label="projectItem.name"
                  :value="projectItem.id"
                  v-for="(projectItem, projectIndex) in exportprojectList"
                  :key="'projectItem' + projectIndex"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="info" @click="closeExportDialog">取 消</el-button>
        <el-button type="primary" @click="exportBtnPressed()">导 出</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {
  exportExcelService2, //导出
} from "../../../services/allContractServices";
import {
  getSupplierEvaluateList, //查询供应商评价列表
  getEvaluateUserService, //查询用户权限
  exportevaluateListExcel, //导出评分列表
  exportscoreExportExcel, //导出集团总台帐
  exportDeptExcel, //导出项目部总台帐
  exportProjectDeptExcel, //导出项目部项目总台帐
} from "@/services/supplierMagServices";
import {
  getDeptList, //获取项目部下拉列表
  getProjectList, ////获取项目部項目下拉列表
} from "../../../services/financeService";

import projectEvaluate from "./subComponents/projectEvaluate"; //生产部门综合评定弹窗
import masterEvaluate from "./subComponents/masterEvaluate"; //主管部门综合评定弹窗

export default {
  name: "evaluateSupplier",
  components: {
    projectEvaluate, //生產部門彈窗組件
    masterEvaluate, //主管部門彈窗組件
  },
  data() {
    return {
      deptList: [], //可供选择的项目部的列表
      projectList: [], //项目列表
      exportprojectList: [], //导出项目列表
      total: 0, //角色总数
      isAddDialogShow: false, //新增弹窗显示开关
      isAdd: false, //true新增 false修改角色标识
      evaluateSupplier: [], //可选组织列表
      menuRoleCode: "", //授权菜单的roleCode
      SelectedRow:[],
      pageIndex: 1,
      pageSize: 20,
      showAdvanceFilter: false, //是否展开高级搜索
      Evaluateform: {
        contractCode: "", // 合同编号
        projectDeptId: undefined, //项目部id
        projectId: "", // 项目名称
        supplierName: "", //合作单位名称
        isScored: "", //1是 0否
        // dutyDeptLevel: "", //主管部门综合评分
        productDeptLevel: "", //生产部门综合评分
        pageIndex: 1,
        pageSize: 20,
      },

      addForm: {
        deptId: "", //项目部
        projectId: "", //项目
      },
      tableColumnDatas: [
        { class: "contractCode", labelName: "合同编号", sortEnable: false },
        // { class: "typeDisplayName", labelName: "分类", sortEnable: false },
        { class: "contractName", labelName: "合同名称", sortEnable: false },
        {
          class: "supplierName",
          labelName: "合作单位名称",
          sortEnable: false,
        },
        { class: "projectDeptName", labelName: "项目部", sortEnable: false },
        { class: "projectName", labelName: "项目", sortEnable: false },
        { class: "scoreYear", labelName: "评定年份", sortEnable: false },
        { class: "score", labelName: "项目评分", sortEnable: false },
        {
          class: "productDeptLevelDisplayName",
          labelName: "生产部门综合评定",
          sortEnable: false,
        },
        {
          class: "dutyDeptCommentDisplayName",
          labelName: "主管部门综合评定",
          sortEnable: false,
        },
      ],
      addRules: {
        companyName: [
          { required: true, message: "请输入子目号" },
          // { min: 1, max: 20, message: "输入内容长度必须介于1到20之间" }
        ],
        namsubCategoryName: [
          { required: true, message: "请输入子目名称" },
          // { min: 1, max: 20, message: "输入内容长度必须介于1到20之间" }
        ],
        unit: [
          { required: true, message: "请输入单位" },
          // { min: 1, max: 20, message: "输入内容长度必须介于1到20之间" }
        ],
        materialPrice: [
          { required: true, message: "请输入单价" },
          {
            pattern: /^[0-9]+$/,
            message: "只能输入数字",
          },
          // { min: 1, max: 20, message: "输入内容长度必须介于1到20之间" }
        ],
        materialCoefficient: [
          {
            pattern: /^[0-9]+$/,
            message: "只能输入数字",
          },
        ],
        remark: [{ min: 1, max: 60, message: "备注长度必须介于1到60之间" }],
        // type: [{required: true, message: "请选择角色类型"}]
        // deptCode: [{ required: true, message: "请选择组织" }]
      },

      //按钮权限
      btnAuthorize: {
        evaluateUserSet: { key: "evaluateUserSet", btnEnable: false }, //评价账号设置
        export: { key: "export", btnEnable: false }, //导出
        pjeDeptP: { key: "pjeDeptP", btnEnable: false }, //
        pjeDeptTotleP: { key: "pjeDeptTotleP", btnEnable: false }, //
        groupTotleP: { key: "groupTotleP", btnEnable: false },
        ProductEvl: { key: "groupTotleP", btnEnable: true }, //生产部门综合评定
        SupperEvl: { key: "SupperEvl", btnEnable: true }, //主管部门综合评定
      },
    };
  },
  props: {
    menuCode: {
      type: String,
    },
  },
  methods: {
    //激活时调用
    onActive(menuCode) {
      this.$getRoleBtns(menuCode, this.btnAuthorize);
      // this.pageIndex = 1;
      // this.pageSize = 20;
      this.getDeptList();
      this.initList();
    },
    /* 查询按钮回调 */
    selectClick() {
      this.Evaluateform.pageIndex = 1;
      this.initList();
    },
    /* 重置按钮回调 */
    resetClick() {
      // this.$refs.form.resetFields();
      for (let key in this.Evaluateform) {
        if (key != "pageIndex" && key != "pageSize") {
          this.Evaluateform[key] = "";
        }
      }
    },
    //获取列表
    initList() {
      // let param = {
      //   // userId: sessionStorage.getItem("userCode"),
      //   pageIndex: this.pageIndex,
      //   pageSize: this.pageSize,
      // };

      getSupplierEvaluateList(this.Evaluateform)
        .then((res) => {
          if (res.code == 10000000) {
            this.evaluateSupplier = res.data;
            this.total = res.total;
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    }, //
    /* 分页改变事件 */
    handleCurrentChange(page) {
      console.log(page);
      this.Evaluateform.pageIndex = page;
      this.initList();
    },
    /* 分页显示数量改变事件 */
    handleSizeChange(rows) {
      this.Evaluateform.pageSize = rows;
      this.Evaluateform.pageIndex = 1;
      this.initList();
    },
    /* 打开生产部门综合评分弹窗 */
    groupTotlePSet(row) {
      // if(row.productDeptLevel!=null)
      // {
      //    this.$alert('供应商生产部门已评分', "提示", {
      //           confirmButtonText: "确定",
      //         });
      //         return

      // }
      let param = {};
      param.deptId = row.projectDeptId;
      param.type = "product_dept";
      // let flag = false;
      // this.$refs.projectEvaluate.showDialog(row, flag);
      getEvaluateUserService(param)
        .then((res) => {
          if (res.code == 10000000) {
            let flag = false;
            this.$refs.projectEvaluate.showDialog(row, flag);
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    },

    /* 打开主管部门综合评分弹窗 */
    masterTotlePSet(row) {
      if (!row.score) {
        this.$alert("请先完成生产部门评分", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      let param = {};
      param.deptId = row.projectDeptId;
      param.type = "duty_dept";
      // this.$refs.masterEvaluate.showDialog(row); //this.row.id);

      getEvaluateUserService(param)
        .then((res) => {
          if (res.code == 10000000) {
            //  let flag=false
            this.$refs.masterEvaluate.showDialog(row); //this.row.id);
          } else {
            if (res.code > 20000000) {
              this.$alert(res.msg, "提示", {
                confirmButtonText: "确定",
              });
            } else {
              this.$alert("系统异常", "提示", {
                confirmButtonText: "确定",
              });
            }
          }
        })
        .catch((error) => {
          this.$message.error("系统异常");
        });
    },
    /* 打开设置用户账户弹窗 */
    addAccountSetDlog() {
      let memberData = {};
      memberData.editFlag = false; //新增标志为0
      memberData.topType = "bType"; // 供应商乙方
      // memberData.path = "order-list";
      this.bus.$emit("navMenuChange", {
        routeId: "evaluateAccountSet",
        routeParam: memberData,
      });
    },
    //获取项目部下拉列表数据
    getDeptList() {
      // 获取可供选择的项目部的列表
      getDeptList()
        .then((res) => {
          if (res.code == 10000000) {
            this.deptList = res.data || [];
          } else {
            this.$alert(res.msg, "提示");
          }
        })
        .catch((error) => {
          this.$alert(error instanceof Error ? error.message : error, "提示");
        });
    },

    //获取项目部下項目列表数据
    getProjectList() {
      // 获取可供选择的项目部的列表
      if (
        this.Evaluateform.projectDeptId &&
        this.Evaluateform.projectDeptId !== ""
      ) {
        let paramsData = {
          deptId: this.Evaluateform.projectDeptId,
        };
        getProjectList(paramsData)
          .then((res) => {
            if (res.code == 10000000) {
              this.projectList = res.data || [];
            } else {
              this.$alert(res.msg, "提示");
            }
          })
          .catch((error) => {
            this.$alert(error instanceof Error ? error.message : error, "提示");
          });
      }
    },
    //获取导出弹窗项目部下項目列表数据
    getExportProjectList() {
      // 获取可供选择的项目部的列表
      if (this.isAdd) {
        let paramsData = {
          deptId: this.addForm.deptId,
        };
        getProjectList(paramsData)
          .then((res) => {
            if (res.code == 10000000) {
              this.exportprojectList = res.data || [];
            } else {
              this.$alert(res.msg, "提示");
            }
          })
          .catch((error) => {
            this.$alert(error instanceof Error ? error.message : error, "提示");
          });
      }
    },

    /* 打开导出项目部项目台账弹窗 */
    openDeptProjectDig() {
      this.isAdd = true; //true为导出项目部项目台账
      this.isAddDialogShow = true;
    },
    /* 打开导出项目部台账弹窗 */
    openDeptDig() {
      this.isAdd = false; //true为导出项目部台账
      this.isAddDialogShow = true;
    },

    closeExportDialog() {
      this.$refs.addForm.resetFields();
      this.isAddDialogShow = false;
      this.addForm.deptId = "";
      this.exportprojectList = [];
      this.addForm.projectId = "";
    },

    /* 导出 */
    exportCurrentList() {
      exportevaluateListExcel(this.Evaluateform)
        .then((res) => {
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              this.$alert("导出成功", "提示", {
                confirmButtonText: "确定",
              });
            });
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(() => {});
    },
    //导出集团总台账
    exportTotleList() {
      exportscoreExportExcel()
        .then((res) => {
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              this.$alert("导出成功", "提示", {
                confirmButtonText: "确定",
              });
            });
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(() => {});
    },
    assignBtnPressed() {
      if (this.SelectedRow.length != 1) {
        this.$alert("每次只能选择一条记录进行修改！", "提示");
      } else {
        this.menuRoleCode = this.SelectedRow[0].id;
        this.$refs.RoleMenuAssignDialog.refreshMenu(this.menuRoleCode);
      }
    },

    /* 弹窗保存按钮回到 */
    exportBtnPressed() {
      this.$refs.addForm.validate((res) => {
        if (res) {
          if (!this.isAdd) {
            this.exportDeptExcel();
          } else {
            this.exportProjectDeptExcel();
          }
        }
      });
    },
    /* 导出项目部列表 */
    exportDeptExcel() {
      exportDeptExcel(this.addForm)
        .then((res) => {
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              this.$alert("导出成功", "提示", {
                confirmButtonText: "确定",
              });
            });
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(() => {});
    },
    /* 导出项目部项目列表 */
    exportProjectDeptExcel() {
      exportProjectDeptExcel(this.addForm)
        .then((res) => {
          if (res.code == 10000000) {
            exportExcelService2(res.data).then((res1) => {
              this.$alert("导出成功", "提示", {
                confirmButtonText: "确定",
              });
            });
          } else if (res.code >= 20000000) {
            this.$alert(res.msg, "提示", {
              confirmButtonText: "确定",
            });
          } else {
            this.$alert("系统异常", "提示", {
              confirmButtonText: "确定",
            });
          }
        })
        .catch(() => {});
    },
    /* 列表多选回调 */
    handleSelectionChange(roleList) {
      this.SelectedRow = roleList;
    },
    // 点击选中行
    rowClicked(row, event, column) {
      this.$refs.dataTable.toggleRowSelection(row);
    },
    //双击查看该项详情
    subCategoryDetail(row) {
      if (row.score) {
        let flag = true;
        this.$refs.projectEvaluate.showDialog(row, flag);
      } else {
        this.$message.warning("该供应商还未评价");
      }
    },

    moreScreen() {
      this.showAdvanceFilter = !this.showAdvanceFilter;
      if (this.showAdvanceFilter) {
        this.tableHeight = this.$refs.main.$el.offsetHeight - 144 - 10;
      } else {
        this.tableHeight = this.$refs.main.$el.offsetHeight + 144 - 10;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import "@/assets/css/commonLayout.scss";
.evaluateSupplier {
  height: 100%;
  background-color: white;
  display: flex;
  flex-direction: column;
}
.screenPanel {
  text-align: left;
  min-height: 40px;
  padding: 16px 0 0 0;
}
.handlePanel {
  text-align: right;
  // padding: 0 20px;
}
.el-select {
  width: 100%;
}
.el-form-item__label {
  text-align: left;
}
.el-footer {
  text-align: right;
}
/deep/.el-radio-button__inner {
  background: #d5e7ed;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
/deep/.el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background: #fff;
  color: #069dbc;
  border: none;
  border-radius: 0;
  box-shadow: none;
  :hover {
    background: #069dbc;
    color: #fff;
  }
}
</style>
